import { Component , OnInit} from '@angular/core';
import AOS from 'aos';
import { ApplicationUserService } from './core/services/application-user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  constructor(private applicationUserService: ApplicationUserService) {}

  ngOnInit() {
    AOS.init();

    // Banka hareketi bildirimi ApplicationUserService'e ait: bağlantı ve dinleyici orada,
    // tek yerde kuruluyor. Burada yalnızca "uygulama açıldı, oturum varsa bağlan" tetiği
    // veriliyor; çağrı idempotent olduğu için login sonrası tekrarı sorun değil.
    this.applicationUserService.connectBankAccountHub();
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
}
